import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { translate } from 'react-i18next'
import Select from 'react-select'
import { connect } from 'react-redux'
import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'

class RegionCompanySelect extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool.isRequired,
    translate: PropTypes.func.isRequired,
    selectedBranches: PropTypes.array.isRequired,
    user: PropTypes.object,
    name: PropTypes.string,
    showInternalServices: PropTypes.bool,
    labelAll: PropTypes.string,
    initialValues: PropTypes.object,
    updateValues: PropTypes.func,
    excludeInactive: PropTypes.bool,
  }

  constructor(props) {
    super(props)

    this.state = {
      companies: [],
      companyOptions: [],
      error: null,
      loading: false,
    }
  }

  componentDidMount() {
    const { user, excludeInactive } = this.props

    this.setState({ loading: true })

    /* istanbul ignore else */
    if (user) {
      const endpoint = excludeInactive ? `${API_URL.BRANCHES}?excludeInactive=true` : API_URL.BRANCHES
      return new Api(user.dsToken)
        .post(endpoint)
        .then((response) => this.onFetchSuccess(response.data))
        .catch((error) => this.onFetchError(error))
    }
  }

  onFetchSuccess(companies) {
    const { showInternalServices, translate, initialValues, updateValues } =
      this.props

    const regionCompanies = []
    const companyOptions = []

    companies.map((company) => {
      if (regionCompanies[company.idRegion] === undefined) {
        regionCompanies[company.idRegion] = []
        regionCompanies[company.idRegion].idRegion = company.idRegion
        regionCompanies[company.idRegion].dsRegion = company.dsRegion
        regionCompanies[company.idRegion].branches = []
      }
      regionCompanies[company.idRegion].branches.push(company)
    })

    regionCompanies.sort((a, b) => {
      if (a.dsRegion < b.dsRegion) {
        return -1
      }
      if (a.dsRegion > b.dsRegion) {
        return 1
      }
      return 0
    })

    regionCompanies.map((region) => {
      companyOptions.push({
        value: region.idRegion,
        label: region.dsRegion,
        visible: true,
      })
      region.branches.map((branch) => {
        companyOptions.push({
          value: branch.id,
          label: `${branch.id} - ${branch.name}`,
          isBranch: true,
          idRegion: branch.idRegion,
          visible: true,
        })
      })

      return region
    })

    if (showInternalServices) {
      companyOptions.push({
        value: 999,
        label: `0999 - ${translate('analytics.matrix.name')}`,
        isBranch: true,
        isBold: true,
        visible: true,
      })
    }

    if (initialValues) {
      const regions = companyOptions.filter((e) => !e.isBranch)
      const selected = []

      regions.forEach((region) => {
        const brachsOfRegions = companyOptions.filter(
          (e) => e.isBranch && e.idRegion === region.value
        )
        const selectBrachsRegion = initialValues.idBranch.reduce(
          (total, current) => {
            const branch = brachsOfRegions.find((e) => e.value === current)
            if (branch) {
              total.push({
                value: branch.value,
                label: branch.label,
                isBranch: true,
                idRegion: branch.idRegion,
                visible: true,
              })
            }
            return total
          },
          []
        )

        if (brachsOfRegions.length === selectBrachsRegion.length) {
          selected.push(region)
        } else {
          selected.push(...selectBrachsRegion)
        }
      })
      this.setState(
        { companyOptions, companies, loading: false, error: null },
        () => {
          updateValues(selected, companyOptions)
        }
      )
    } else {
      this.setState({ companyOptions, companies, loading: false, error: null })
    }
  }

  onFetchError(error) {
    this.setState({ error, loading: false, companies: [] })
  }

  filterOptions = (option, inputValue) => {
    inputValue = inputValue.toLowerCase()
    const lcLabel = option.label.toLowerCase()

    const matches = lcLabel.includes(inputValue)

    return matches && option.data.visible
  }

  renderOption(option) {
    let classForOption =
      option.isBranch && !option.isBold ? 'option-branch' : 'option-region'
    if (!option.visible) {
      classForOption = classForOption.concat(' hidden')
    }

    return (
      <option value={option.value} className={classForOption}>
        {option.label}
      </option>
    )
  }

  render() {
    const { name, onChange, translate, selectedBranches, disabled, labelAll } =
      this.props
    const { companyOptions, loading } = this.state

    const labelLoaded = labelAll || translate('ruptures.idBranch')

    const label = loading ? translate('ruptures.loading') : labelLoaded

    return (
      <Select
        id='idRegion'
        isMulti
        closeMenuOnSelect={false}
        className={'react-select react-select-multi'}
        classNamePrefix={'react-select'}
        name={name}
        placeholder={label}
        options={companyOptions}
        value={selectedBranches}
        onChange={(event) =>
          onChange(event, companyOptions, this.handleOptionsSelected)
        }
        filterOption={(option, inputValue) =>
          this.filterOptions(option, inputValue)
        }
        isDisabled={disabled}
      />
    )
  }
}

/* istanbul ignore next */
const mapStateToProps = ({ auth }) => ({
  user: auth.user,
})

/*
 * Connects component to I18next
 */
/* istanbul ignore next */
const CompanySelectTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(RegionCompanySelect)

/*
 * Exports component connected to redux
 */
/* istanbul ignore next */
export default connect(mapStateToProps)(CompanySelectTranslated)

/*
 * Exports component only
 */
/* istanbul ignore next */
export { RegionCompanySelect }
